// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__zXOGt","item":"PaymentsMobile_item__1RMPa","label":"PaymentsMobile_label__1NdA2","amount":"PaymentsMobile_amount__3tTBC"};